import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { linkWithUnderlineHover } from 'styles/mixins';

const Wrapper = styled.div`

`;

const List = styled.ul`
  margin: 0 0 2rem;
  list-style: none;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: .8rem;
  & + & {
    margin-top: .5rem;
  }
`;

const ListLink = styled(Link)`
  min-width: 4rem;
  span {
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.secondary)};
  }
`;

const NumberWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  background: ${(props) => props.theme.color.gray};
  font-size: 1.1rem;
  color: ${(props) => props.theme.mainColors.primary};
`;

const AddText = styled.span`
  font-size: 1rem;
  color: ${(props) => props.theme.color.darkGray};
`;

export {
  Wrapper,
  List,
  ListItem,
  ListLink,
  NumberWrapper,
  AddText
};
